import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const deleteTenant = createAsyncThunk('deleteTenant', async (object, { rejectWithValue }) => {
  const response = await request(`/api/v1/tenants-delete/${object.tenantId}`, { method: 'DELETE', auth: true});

  if (response) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});